const BASE_PATH = '/illustrations/plumbing';

/**
 * L'ordre compte : la première règle dont un mot-clé est contenu dans le
 * libellé gagne. Les cas particuliers (« Chauffe-bain », « Évacuation
 * extérieure ») passent donc avant les règles plus générales.
 */
const ILLUSTRATION_RULES = [
  { file: 'fixture_bathtub', keywords: ['baignoire'] },
  { file: 'fixture_water_heater', keywords: ['chauffe-eau', 'chauffe eau', 'chauffe-bain', 'chauffe bain', 'ballon', 'cumulus'] },
  { file: 'fixture_shower', keywords: ['douche'] },
  { file: 'fixture_sink', keywords: ['evier', 'lavabo', 'vasque'] },
  { file: 'fixture_dishwasher', keywords: ['lave-vaisselle', 'lave vaisselle'] },
  { file: 'room_laundry', keywords: ['buanderie', 'lave-linge', 'lave linge', 'machine a laver'] },
  { file: 'room_toilet', keywords: ['toilette', 'wc'] },
  { file: 'issue_leak', keywords: ['fuite', 'autre'] },
  { file: 'fixture_water_inlet', keywords: ['arrivee d', 'alimentation', 'adduction'] },
  { file: 'fixture_drain', keywords: ['evacuation', 'canalisation', 'debouchage'] },
  { file: 'room_kitchen', keywords: ['cuisine'] },
  { file: 'room_bathroom', keywords: ['salle de bain', 'salle d eau', 'sdb'] },
  { file: 'room_garden', keywords: ['jardin', 'arrosage', 'irrigation', 'robinet exterieur', 'exterieur'] },
];

const normalize = (value) =>
  (value || '')
    .toString()
    .toLowerCase()
    .replace(/[’‘']/g, ' ')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

/**
 * Illustration de la série correspondant à un libellé de pièce ou
 * d'équipement. Renvoie null quand aucun visuel ne correspond.
 */
export const getPlumbingIllustration = (label) => {
  const normalized = normalize(label);
  if (!normalized) return null;

  const rule = ILLUSTRATION_RULES.find(({ keywords }) =>
    keywords.some((keyword) => normalized.includes(keyword))
  );

  return rule ? `${BASE_PATH}/${rule.file}.svg` : null;
};

/**
 * Source d'image à afficher. L'illustration de la série est prioritaire pour
 * garantir un style homogène ; le visuel du catalogue reste utilisé pour les
 * libellés hors série. Ne modifie pas la logique de sélection.
 */
export const resolveIllustrationSource = (catalogSource, label) => {
  const illustration = getPlumbingIllustration(label);
  if (illustration) return illustration;

  const source = (catalogSource || '').toString().trim();
  if (source.startsWith('http') || source.startsWith('/')) return source;

  return null;
};
